import { motion } from "framer-motion";

// Signature ECG heartbeat motif — an infinitely scrolling ECG line.
const SEGMENT =
  "M0 40 L60 40 L72 40 L84 12 L96 68 L108 40 L130 40 L142 40 L150 30 L158 40 L200 40";

export const Heartbeat = ({ color = "#D62828", className = "", height = 80 }) => {
  return (
    <div
      className={`w-full overflow-hidden ${className}`}
      style={{ height }}
      aria-hidden="true"
      data-testid="heartbeat-motif"
    >
      <motion.div
        className="flex h-full"
        animate={{ x: ["0%", "-50%"] }}
        transition={{ repeat: Infinity, ease: "linear", duration: 6 }}
      >
        {[0, 1, 2, 3, 4, 5, 6, 7].map((i) => (
          <svg
            key={i}
            viewBox="0 0 200 80"
            preserveAspectRatio="none"
            style={{ height: "100%", width: 200, flex: "0 0 auto" }}
          >
            <path
              d={SEGMENT}
              fill="none"
              stroke={color}
              strokeWidth="3"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        ))}
      </motion.div>
    </div>
  );
};
